import { PlaceContent, PlaceRange } from './types';
import { ReactComponent as FirstPlaceIcon } from '@/assets/Icons/gold.svg';
import { ReactComponent as SecondPlaceIcon } from '@/assets/Icons/silver.svg';
import { ReactComponent as ThirdPlaceIcon } from '@/assets/Icons/bronze.svg';

export const getPlaceContent = (range: PlaceRange): PlaceContent => {
  const { start, end } = range;

  if (start === end) {
    switch (start) {
      case 1:
        return { 
          type: 'first', 
          display: {
            type: 'image',
            src: FirstPlaceIcon,
            alt: 'First Place'
          }
        };
      case 2:
        return { 
          type: 'second', 
          display: {
            type: 'image',
            src: SecondPlaceIcon,
            alt: 'Second Place'
          }
        };
      case 3:
        return { 
          type: 'third', 
          display: {
            type: 'image',
            src: ThirdPlaceIcon,
            alt: 'Third Place'
          }
        };
      default:
        return { type: 'other', display: `${start}` };
    }
  }

  return { type: 'other', display: `${start}-${end}` };
}; 